import React from 'react';
import { Modal, Row, Col, Select, message, Icon } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';

const Option = Select.Option;

class OptionCutOff extends React.Component {
    state = {
        list: [],
        visible: false,
        moduleDefine: {},
        confirmLoading: false,
    }
    
    show = (moduleDefine) => {
        const { moduleDefineConstraintValue } = moduleDefine;
        const list = moduleDefineConstraintValue ? moduleDefineConstraintValue.split('//') : [];
        const newList = list.map(item => ({ optionName: item }));
        this.setState({
            moduleDefine,
            list: newList,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            list: [],
            textList: [],
            visible: false,
        });
    }

    handleTextSelect = (value, index) => {
        const { list } = this.state;
        list[index].targetName = value;
        this.setState({ list });
    }

    getTextContent = () => {
        const { moduleDefineList } = this.props;
        const { list, moduleDefine: { visitTypeId } } = this.state;
        const targetModuleDefine = moduleDefineList.find(item => item.moduleDefineId == visitTypeId) || {};
        const targetList = targetModuleDefine.moduleDefineConstraintValue ? targetModuleDefine.moduleDefineConstraintValue.split('//') : [];
        const options = targetList.map(item => <Option key={item} value={item}>{item}</Option>);
        return (
            <div>
                {
                    list.length ?
                        <div>
                            <Row style={{ minHeight: '20px', fontWeight: 'bold'}}>
                                <Col span={10} style={{textAlign: 'left'}}>待割接可选项</Col>
                                <Col span={14} style={{textAlign: 'left'}}>割接后可选项</Col>
                            </Row>
                            {
                                list.map((item, index) => (
                                    <Row key={index} style={{borderBottom: '1px solid #ccc', margin: '10px 0px'}}>
                                        <Col span={10} style={{textAlign: 'left', marginTop: 6}}>{item.optionName}</Col>
                                        <Col span={14} style={{textAlign: 'left'}}>
                                            <Select
                                                allowClear={true}
                                                style={{width: 160}}
                                                placeholder='请选择'
                                                onChange={(value) => this.handleTextSelect(value, index)}
                                            >
                                                {options}
                                            </Select>
                                        </Col>
                                    </Row>
                                ))
                            }
                        </div>
                    :
                        <div style={{ marginTop: 100, marginBottom: 100, textAlign: 'center' }}>
                            <Icon type="frown-o" style={{ marginRight: 4, fontSize: '16px', color: '#999' }} />
                            暂无数据
                        </div>
                }
            </div>
        )
    }

    confirm = () => {
        const { list, visitGroupingId, moduleDefine: { moduleDefineId, visitTypeId } } = this.state;
        const params = {};
        list.forEach(item => {
            if (item.targetName) {
                params[`params[${item.optionName}]`] = item.targetName;
            }
        });

        this.setState({confirmLoading: true});

        const options = {
            url: API_URL.executeMgr.optionModuleDefineCutOver,
            data: {
                ...params,
                visitGroupingId,
                moduleDefineId,
                targetModuleDefineId: visitTypeId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    confirmLoading: false
                });
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            },
            failResult: () => {
                this.setState({ confirmLoading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    render() {
        const { moduleDefineList } = this.props;
        const { visible, confirmLoading, moduleDefine: { moduleDefineName, visitTypeId } } = this.state;
        const targetModuleDefine = moduleDefineList.find(item => item.moduleDefineId == visitTypeId) || {};
        const targetModuleDefineName = targetModuleDefine.moduleDefineName ? targetModuleDefine.moduleDefineName : '';
        return (
            <Modal
                title="可选项割接"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
                confirmLoading={confirmLoading}
            >
                <div style={{marginBottom: 12}}>割接字段：{moduleDefineName} >> {targetModuleDefineName}</div>
                { this.getTextContent() }
            </Modal>
        );
    }
}

class VisitCutOff extends React.Component {
    state = {
        type: '',
        list: [],
        visitTypeList: [],
        isSubmit: true,
        visible: false,
        confirmLoading: false,
        visitGroupingId: '',
        visitGroupingList: [],
    }
    
    show = (type) => {
        const { moduleDefineList } = this.props;
        const list = moduleDefineList.filter(item => item.criteriaDataType == type && item.projectDefineIsDefault == '0');
        let textList = [];
        if (type == 'TEXT') {
            textList = moduleDefineList.filter(item => item.criteriaDataType == type && item.projectDefineIsDefault == '1' && item.moduleDefineName != '录入者');
        }
        this.setState({
            type,
            list,
            textList,
            visible: true,
            visitGroupingId: '',
        }, () => {
            type == 'DATE' && this.loadHead();
        })
    }

    hide = () => {
        this.setState({
            list: [],
            textList: [],
            visible: false,
            visitTypeList: [],
        });
    }

    loadHead = () => {
        const { investigationSiteName } = sessionStorage;
        const obj = {};
        if (!investigationSiteName) {
            obj.publishStatus = 'ALL';
        }
        const options = {
            url: API_URL.plan.queryVisitGrouping,
            data: { ...obj },
            dataType: 'json',
            doneResult: res => {
                if ( res && res.data.length <= 0) {
                    return
                }
                this.setState({
                    visitGroupingList: res.data,
                    visitGroupingId: res.data[0].visitGroupingId + ''
                }, () => {
                    this.loadData();
                });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    loadData = () => {
        const { visitGroupingId } = this.state;
        const options = {
            url: API_URL.plan.visitTypeDataList,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: res => {
                const { visitTypeList = [] } = res.data;
                this.setState({ visitTypeList });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    handleDateSelect = (value, index) => {
        const { list } = this.state;
        list[index].visitTypeId = value;
        this.setState({ list });
    }

    handleSelectChange = (value) => {
        this.setState({ visitGroupingId: value }, () => {
            this.loadData();
        });
    }

    getDateContent = () => {
        const { list, visitTypeList } = this.state;
        const options = visitTypeList.map(item => <Option key={item.visitTypeId} value={item.visitTypeId + ''}>{item.visitTypeName}</Option>);
        return (
            <div>
                {
                    list.map((item, index) => (
                        <Row key={item.criteriaDefineId} style={{borderBottom: '1px solid #ccc', margin: '10px 0px'}}>
                            <Col span={10} style={{textAlign: 'left', marginTop: 6}}>{item.moduleDefineName}</Col>
                            <Col span={14} style={{textAlign: 'left'}}>
                                <Select
                                    allowClear={true}
                                    style={{width: 160}}
                                    placeholder='请选择'
                                    onChange={(value) => this.handleDateSelect(value, index)}
                                >
                                    {options}
                                </Select>
                            </Col>
                        </Row>
                    ))
                }
            </div>
        )
    }

    handleTextSelect = (value, index) => {
        const { list, textList } = this.state;
        if (value) {
            let idx;
            textList.forEach((item, index) => {
                if (item.moduleDefineId == value) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && textList.splice(idx, 1);
        } else {
            const { visitTypeId } = list[index];
            const { moduleDefineList } = this.props;
            const moduleDefine = moduleDefineList.find(item => item.moduleDefineId == visitTypeId);
            moduleDefine && textList.push(moduleDefine);
        }
        list[index].visitTypeId = value;
        this.setState({
            list,
            textList,
        });
    }

    showOptionCutOff = (index) => {
        const { list } = this.state;
        if (!list[index]['visitTypeId']) {
            message.warning('请先选择割接后字段');
            return;
        }
        this.optionCutOffRef.show(list[index]);
    }

    getTextContent = () => {
        const { list, textList = [] } = this.state;
        const options = textList.map(item => <Option key={item.moduleDefineId} value={item.moduleDefineId + ''}>{item.moduleDefineName}</Option>);
        return (
            <div>
                {
                    list.map((item, index) => (
                        <Row key={item.criteriaDefineId} style={{borderBottom: '1px solid #ccc', margin: '10px 0px'}}>
                            <Col span={10} style={{textAlign: 'left', marginTop: 6}}>{item.moduleDefineName}</Col>
                            <Col span={14} style={{textAlign: 'left'}}>
                                <Select
                                    allowClear={true}
                                    style={{width: 160}}
                                    placeholder='请选择'
                                    onChange={(value) => this.handleTextSelect(value, index)}
                                >
                                    {options}
                                </Select>
                                <a style={{ marginLeft: 10 }} onClick={() => this.showOptionCutOff(index)}>可选项割接</a>
                            </Col>
                        </Row>
                    ))
                }
            </div>
        )
    }

    confirm = () => {
        const { type, list } = this.state;
        if (!list.length) {
            this.setState({ visible: false });
            return;
        }
        if (type == 'TEXT') {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: <div style={{ marginLeft: 42 }}>请确定已割接字段的可选项已全部完成割接</div>,
                content: '已割接字段将从列表删除，无法恢复',
                onOk: () => {
                    this.save();
                },
            });
        } else {
            this.save();
        }
    }

    save = () => {
        const { type, list, visitGroupingId } = this.state;
        const params = {};
        list.forEach(item => {
            if (item.visitTypeId) {
                params[`params[${item.moduleDefineId}]`] = item.visitTypeId;
            }
        });

        let url = type == 'DATE' ? API_URL.executeMgr.dateModuleDefineCutOver : API_URL.executeMgr.textModuleDefineCutOver;
        this.setState({confirmLoading: true});

        const options = {
            url,
            data: {
                ...params,
                visitGroupingId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    confirmLoading: false
                });
                this.props.loadData();
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            },
            failResult: () => {
                this.setState({ confirmLoading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    render() {
        const { moduleDefineList } = this.props;
        const { type, list, visible, confirmLoading, visitGroupingId, visitGroupingList } = this.state;
        let title;
        let cutOffName;
        let cutOffValue;
        if (type == 'DATE') {
            title = '时间型字段割接';
            cutOffName = '时间型待割接字段';
            cutOffValue = '访视周期计划-访视次数'
        } else if (type == 'TEXT') {
            title = '文本型字段割接';
            cutOffName = '文本型待割接字段';
            cutOffValue = '割接后字段';
        }
        return (
            <Modal
                title={title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
                confirmLoading={confirmLoading}
            >
                {
                    list.length ?
                        <div>
                            {
                                type == 'DATE' &&
                                <Select
                                    placeholder='请选择'
                                    value={visitGroupingId}
                                    onChange={this.handleSelectChange}
                                    style={{width: 120, marginTop: 10, marginBottom: 20}}
                                >
                                    {visitGroupingList.map(item => <Option key={item.visitGroupingId} value={item.visitGroupingId + ''}>{item.visitGroupingName}</Option>)}
                                </Select>
                            }
                            <Row style={{ minHeight: '20px', fontWeight: 'bold'}}>
                                <Col span={10} style={{textAlign: 'left'}}>{cutOffName}</Col>
                                <Col span={14} style={{textAlign: 'left'}}>{cutOffValue}</Col>
                            </Row>
                            {
                                type == 'DATE' ? this.getDateContent() : this.getTextContent()
                            }
                        </div>
                    :
                        <div style={{ marginTop: 100, marginBottom: 100, textAlign: 'center' }}>
                            <Icon type="frown-o" style={{ marginRight: 4, fontSize: '16px', color: '#999' }} />
                            暂无数据
                        </div>
                }
                <OptionCutOff ref={el => this.optionCutOffRef = el} moduleDefineList={moduleDefineList} />
            </Modal>
        );
    }
}

export default VisitCutOff;



// WEBPACK FOOTER //
// ./src/components/executeMgr/VisitCutOff.js